import { resolveDocumentColorToCss } from "./theme-color-token.js";
const gradientToCss = (gradient) => {
  if (!gradient?.stops?.length) {
    return "";
  }
  const stops = [...gradient.stops].sort((a, b) => (a.position ?? 0) - (b.position ?? 0)).map(
    (stop) => `${resolveDocumentColorToCss(stop.color) ?? "transparent"} ${((stop.position ?? 0) * 100).toFixed(2)}%`
  ).join(", ");
  if (gradient.type === "LINEAR") {
    return `linear-gradient(${gradient.angle ?? 90}deg, ${stops})`;
  }
  if (gradient.type === "RADIAL") {
    return `radial-gradient(circle at ${gradient.centerX ?? 50}% ${gradient.centerY ?? 50}%, ${stops})`;
  }
  return "";
};
export {
  gradientToCss
};
//# sourceMappingURL=gradient-to-css.js.map
